export const refereeSchedules: TableModule = {
    name: "refereeSchedules",
    route: "spa.sportsManagement.refereeSchedules",
    defaultOrder: {
        column: "date",
        direction: "asc"
    },
    columns: [{
        name: "date",
        sortable: true,
        pageLink: true,
        mobile: true,
        width: 'w-[130px]'
    }, {
        name: "city",
        breakpoint: "xl",
        width: 'w-[150px]'
    }, {
        name: "contest",
        sortable: true,
        sortBy: "contests.name",
        breakpoint: "lg",
        width: 'w-[180px]',
    }, {
        name: "opponents",
        width: 'w-1/5',
    }, {
        name: "referees",
        mobile: true,
    }],
    filters: [
        {
            name: "contest",
            column: "contest_id",
            type: "searchSelect",
            reduced: "in",
            spaRoute: "spa.sportsManagement.contests.index",
            additionalDisplayKey: "game_class_name",
            searchThreshold: 1,
            searchSelectConfig: {
                fetchOnSearch: false,
            },
            ability: ['viewAny', 'contests']
        }, {
            name: "date",
            column: "date",
            type: "date",
            reduced: "date[,]",
        }, {
            name: "city",
            column: "customFilterCity",
            type: "string",
            reduced: true
        }
    ],
    quickFilters: [],
    tools: []
}